import { render, staticRenderFns } from "./RegisterForm2Personal.vue?vue&type=template&id=0d9275da&scoped=true&"
import script from "./RegisterForm2Personal.vue?vue&type=script&lang=js&"
export * from "./RegisterForm2Personal.vue?vue&type=script&lang=js&"
import style0 from "./RegisterForm2Personal.vue?vue&type=style&index=0&id=0d9275da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9275da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d9275da')) {
      api.createRecord('0d9275da', component.options)
    } else {
      api.reload('0d9275da', component.options)
    }
    module.hot.accept("./RegisterForm2Personal.vue?vue&type=template&id=0d9275da&scoped=true&", function () {
      api.rerender('0d9275da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/RegisterForm2Personal.vue"
export default component.exports